import { type ProductDetailsData, type ProductDetailsSticksData } from "@jti/fe-common";

import { SticksProductDetailsPage } from "@product-details/containers/SticksProductDetailsContainer/components/SticksProductDetailsPage";

import { ReactQueryClientProvider } from "../../providers";

export type SticksProductDetailsProps = Pick<
  ProductDetailsData,
  | "sku"
  | "badgeText"
  | "overwriteBadgeText"
  | "description"
  | "knowMoreUrl"
  | "multiPackDescription"
  | "productCta"
  | "productName"
  | "hasBadge"
  | "hasDiscountBadge"
  | "hasStrikethroughPrice"
  | "hideCta"
  | "isCommerceDisabled"
  | "isMultiPackEnabled"
  | "hidePrice"
  | "multiPackName"
  | "multiPackProducts"
  | "customBuyCtaLabel"
> & {
  sticksData: ProductDetailsSticksData;
  isSubscriptionsEnabled: boolean;
};

export const SticksProductDetailsContainer = (props: SticksProductDetailsProps) => {
  return (
    <ReactQueryClientProvider>
      <SticksProductDetailsPage {...props} />
    </ReactQueryClientProvider>
  );
};
